import i18next from 'i18next'
import { SupportLanguages } from 'constant/supportLanguage'
import React, { useState } from 'react'
import { Selector } from 'components/OWForm/Inputs/Selector'

export default function LanguageSwitcher() {
    const [language, setLanguage] = useState(i18next.language)

    function handleOnSelect(value: any) {
        i18next.changeLanguage(value)
        setLanguage(value)
    }

    return (
        <Selector
            options={SupportLanguages}
            onChangeCallback={handleOnSelect}
            value={language}
        />
    )
}
